export const OFFRE_EMPLOIS = [
  {
    id_offre: 1,
    titre: "Ingenieur Developpeur senior",
    date_pulication: "11 Fev 2025 à 16:14",
    date_cloture: "25 Mars 2025",
    qualification: [
      { ref: 1, diplome: "Master ou Licence en IT", exige: true, oui: false, file: "" },
    ],
    experience_exige: [
      {
        ref: 1,
        domaine: "developpeur",
        duree: 2,
        unite: "mois",
        exige: true,
        oui: false,
        file: "",
      },
      {
        ref: 3,
        domaine: "Travaillant dans un projet",
        duree: 3,
        unite: "mois",
        exige: false,
        oui: false,
        file: "",
      },
    ],
    autre_critere_exige: [
      { ref: 1, critere: "developpeur", exige: true, oui: false, file: "" },
      {
        ref: 2,
        critere: "developpeur web",
        exige: true,
        oui: false,
        file: "",
      },
      {
        ref: 3,
        critere: "developpeur mobile",
        exige: false,
        oui: false,
        file: "",
      },
    ],
    description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
          Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer
          took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries,
          but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 
          1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing 
          software like Aldus PageMaker including versions of Lorem Ipsum. 1914 translation by H. Rackham "But I must
          explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give 
          you a complete account of the system, and expound the actual teachings of the great explorer of the truth, 
          the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but
          because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. 
          Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but 
          because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example,
          which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who
          has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,
          or one who avoids a pain that produces no resultant pleasure?" Section 1.10.33 of "de Finibus Bonorum et 
          Malorum", written by Cicero in 45 BC "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis
          praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati 
          cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et 
          dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis 
          est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas 
          assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum 
          necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum
          rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis 
          doloribus asperiores repellat." 1914 translation by H. Rackham`,
  },
  {
    id_offre: 2,
    titre: "Secretaire de direction",
    date_pulication: "22 Fev 2025 à 16:14",
    date_cloture: "25 Juin 2025",
    qualification: [
      { ref: 1, diplome: "Licence en IT", exige: true, oui: false, file: "" },
    ],
    experience_exige: [
      {
        ref: 2,
        domaine: "developpeur web",
        duree: 2,
        unite: "ans",
        exige: true,
        oui: false,
        file: "",
      },
    ],
    autre_critere_exige: [],
    description: `src\screens\refonte\mes_demandes\MesDemande.js       
                Line 20:26:  'setOffreEmplois' is assigned a value but never used  no-unused-vars

              src\screens\refonte\offre\OffreEmplois.js
                Line 28:26:  'setOffreEmplois' is assigned a value but never used  no-unused-vars

              src\screens\refonte\offre\PostuleForm.js
                Line 29:6:  React Hook useEffect has missing dependencies: 'jobId' and 'showToast'. Either include them or remove the dependency array  react-hooks/exhaustive-deps

              src\screens\refonte\profile\CV_old.js
                Line 2:3:   'Avatar' is defined but never used     `,
  },
];
